<template>
  <div v-if="imageSrc" class="problem-visual problem-visual--image">
    <img :src="imageSrc" :alt="imageAlt || ''" />
  </div>

  <div v-else-if="visualType === 'triangle-base-height'" class="problem-visual">
    <svg viewBox="0 0 260 120" role="img" aria-label="밑변 5, 높이 2인 삼각형">
      <path d="M25 95 L132 22 L236 95 Z" fill="none" stroke="currentColor" stroke-width="2" />
      <path d="M132 22 L132 95" stroke="currentColor" stroke-width="1.5" stroke-dasharray="4 4" />
      <path d="M132 86 L141 86 L141 95" fill="none" stroke="currentColor" stroke-width="1.4" />
      <text x="144" y="60">2</text>
      <line x1="25" y1="105" x2="236" y2="105" stroke="#777" stroke-dasharray="3 4" />
      <text x="128" y="117">5</text>
    </svg>
  </div>

  <div v-else-if="visualType === 'coordinate-distance'" class="problem-visual">
    <svg viewBox="0 0 220 150" role="img" aria-label="원점에서 4,3까지의 좌표 그래프">
      <g stroke="#d9dce3" stroke-width="1">
        <path v-for="x in [45,75,105,135,165]" :key="`x-${x}`" :d="`M${x} 15 V130`" />
        <path v-for="y in [30,55,80,105]" :key="`y-${y}`" :d="`M30 ${y} H190`" />
      </g>
      <path d="M30 130 H195 M45 140 V12" stroke="#34343d" stroke-width="1.5" />
      <path d="M45 130 L165 55" stroke="#d4a52a" stroke-width="2.5" />
      <circle cx="45" cy="130" r="3" fill="#34343d" />
      <circle cx="165" cy="55" r="3" fill="#34343d" />
      <text x="32" y="122">(0,0)</text>
      <text x="168" y="50">(4,3)</text>
      <text x="188" y="127">x</text>
      <text x="50" y="20">y</text>
    </svg>
  </div>

  <div v-else-if="visualType === 'number-compare'" class="problem-visual problem-visual--numbers">
    <span>0.7,</span><span>8/12,</span><span>0.85,</span><span>4/5</span>
  </div>

  <div v-else-if="visualType === 'semicircle-similarity'" class="problem-visual">
    <svg viewBox="0 0 280 105" role="img" aria-label="넓이가 10인 파란 반원과 축소된 반원">
      <path d="M20 82 A55 55 0 0 1 130 82 Z" fill="#a9dff4" stroke="#69757e" stroke-width="1.5" />
      <path d="M160 82 A45 45 0 0 1 250 82 Z" fill="#a9dff4" stroke="#69757e" stroke-width="1.5" />
      <path d="M20 82 Q47 55 75 82 Q102 55 130 82" fill="#fff" stroke="#69757e" stroke-width="1" />
      <path d="M160 82 Q171 68 182 82 Q193 68 205 82 Q216 68 227 82 Q238 68 250 82" fill="#fff" stroke="#69757e" stroke-width="1" />
      <text x="69" y="50" text-anchor="middle">10</text>
      <text x="205" y="50" text-anchor="middle">?</text>
    </svg>
  </div>

  <div v-else-if="visualType === 'right-triangle'" class="problem-visual">
    <svg viewBox="0 0 200 160" role="img" aria-label="빗변 10과 내부 길이 6이 표시된 직각삼각형">
      <path d="M40 130 L40 25 L150 130 Z" fill="#f9f9fb" stroke="#5d616a" stroke-width="2" />
      <path d="M40 130 L110 70" stroke="#5d616a" stroke-width="1.5" stroke-dasharray="4 3" />
      <path d="M40 118 H52 V130" fill="none" stroke="#5d616a" stroke-width="1.5" />
      <text x="113" y="65">10</text>
      <text x="70" y="103">6</text>
    </svg>
  </div>

  <div v-else-if="visualType === 'quadrilateral-conditions'" class="problem-visual problem-visual--condition">
    <span>단, 모든 모서리각(내각)은 180도보다 작음</span>
  </div>
</template>

<script setup lang="ts">
import type { VisualType } from '@/types/content'

withDefaults(
  defineProps<{
    visualType?: VisualType
    imageSrc?: string
    imageAlt?: string
  }>(),
  {
    visualType: 'none',
    imageSrc: '',
    imageAlt: '',
  },
)
</script>
